export function brandDisplayColors(palette: unknown): { label: string; hex: string }[] {
  if (!Array.isArray(palette)) return [];
  return palette.flatMap((entry, index) => {
    const hex = typeof entry === "string" ? entry : entry?.hex;
    if (typeof hex !== "string") return [];
    const label = typeof entry === "object" && entry !== null && typeof entry.label === "string"
      ? entry.label : `Color ${index + 1}`;
    return [{ label, hex }];
  });
}
